import { Stack } from '@mui/system';
import { mapIndustry } from 'tdc-web-backend/enums/enums';
import { EnumIndustry } from 'tdc-web-backend/enums/enums';
import { Dispatch, SetStateAction } from 'react';
import CustomChip from '../../../../../../../../../components/custom-chip/CustomChip';
import { truncate } from '../../../../../../../../../utils/helpers';
import CompanyTargetIndustriesEditModal from './components/CompanyTargetIndustriesEditModal';
import { CHIP_LABEL_TRUNCATE_VALUE } from '../../../../../../../../../utils/constants';
import useUserCompany from '../../../../../../../../../utils/hooks/useUserCompany';
import { useTranslation } from 'react-i18next';

interface CompanyTargetIndustriesProps {
  isEditModalOpen: boolean;
  setIsEditModalOpen: Dispatch<SetStateAction<boolean>>;
}

const CompanyTargetIndustries = ({
  isEditModalOpen,
  setIsEditModalOpen,
}: CompanyTargetIndustriesProps) => {
  const { t } = useTranslation();
  const { company: companyData } = useUserCompany();

  return (
    <Stack
      direction="row"
      gap={1}
      flexWrap="wrap"
      alignItems="flex-start"
      justifyContent="flex-start"
    >
      {companyData?.targetIndustries?.map((industry: EnumIndustry) => (
        <CustomChip
          key={industry}
          tooltipTitle={t(mapIndustry.get(industry) ?? '', { ns: 'enum' })}
          label={
            industry &&
            truncate(
              t(mapIndustry.get(industry) ?? '', { ns: 'enum' }),
              CHIP_LABEL_TRUNCATE_VALUE as number,
            )
          }
          sx={{ width: 'fit-content', textTransform: 'capitalize' }}
        />
      ))}
      {companyData && (
        <CompanyTargetIndustriesEditModal
          isEditModalOpen={isEditModalOpen}
          setIsEditModalOpen={setIsEditModalOpen}
        />
      )}
    </Stack>
  );
};

export default CompanyTargetIndustries;
